import Faq from './Faq';

export * from './types';
export default Faq;
